/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Volume_So_FarInputs */

const en_us2_progress_volume_so_far = /** @type {(inputs: Progress_Volume_So_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this week, so far`)
};

const pt_br2_progress_volume_so_far = /** @type {(inputs: Progress_Volume_So_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nesta semana, até agora`)
};

const es_419_progress_volume_so_far = /** @type {(inputs: Progress_Volume_So_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esta semana, hasta ahora`)
};

const pt_pt2_progress_volume_so_far = /** @type {(inputs: Progress_Volume_So_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esta semana, até agora`)
};

const fr_fr2_progress_volume_so_far = /** @type {(inputs: Progress_Volume_So_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cette semaine, jusqu'ici`)
};

const de_de2_progress_volume_so_far = /** @type {(inputs: Progress_Volume_So_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`diese Woche, bisher`)
};

const it_it2_progress_volume_so_far = /** @type {(inputs: Progress_Volume_So_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`questa settimana, finora`)
};

/**
* | output |
* | --- |
* | "this week, so far" |
*
* @param {Progress_Volume_So_FarInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_volume_so_far = /** @type {((inputs?: Progress_Volume_So_FarInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Volume_So_FarInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_volume_so_far(inputs)
	if (locale === "es-419") return es_419_progress_volume_so_far(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_volume_so_far(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_volume_so_far(inputs)
	if (locale === "de-DE") return de_de2_progress_volume_so_far(inputs)
	if (locale === "it-IT") return it_it2_progress_volume_so_far(inputs)
	return en_us2_progress_volume_so_far(inputs)
});
export { progress_volume_so_far as "progress.volume_so_far" }